module.exports = __webpack_public_path__ + "img/item_vehicle@2x.8a7a63b6.png";